<template>
  <div class="m-sidebar-nav">
    <ul class="m-sidebar-nav__main">
      <li>
        <span class="m-sidebar-nav__link">
          <router-link to="/selectors/icons">Icons</router-link>

          <ul class="m-sidebar-nav__list subnav" v-if="$route.path.startsWith('/selectors/icons')" >
            <li class="m-sidebar-subnav__list__item">
              <span class="m-sidebar-nav__link">
                <router-link :to="{name: 'selector-icons'}">All</router-link>
              </span>
            </li>
            <li v-for="category in iconCategories" :key="category.id" class="m-sidebar-subnav__list__item">
              <span class="m-sidebar-nav__link">
                <router-link :to="{name: 'selector-icons', params: {categoryId: category.id}}">{{category.name}}</router-link>
              </span>
            </li>
          </ul>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  props: {
  },

  apollo: {
    iconCategories: {
      query: gql`
        query iconCategories {
          iconCategories {
            id
            name
          }
        }
      `,
    }
  },

}
</script>

<style lang="scss" scoped>
  @import '../styles/mixins.scss';

  .m-sidebar-nav {
    position: sticky;
    // height: calc(100vh - 100px);
    overflow: auto;
    top: 40px;
    width: 100%;
    // max-width: 200px;
    padding-left: 35px;

    a.active {
      font-family: var(--f-bold);
    }

    @include bp(680px) {
      max-width: none;
      position: static;
      padding-bottom: 12px;
      padding-right: 12px;
    }

    &__list {
      @include bp(680px) {
        display: flex;
        flex-wrap: wrap;
      }

      &.subnav {
        li {
          margin-left: 20px;
        }
        a {

        }
        a.active {
          font-family: var(--f-normal);
        }

        a.router-link-exact-active {
          font-family: var(--f-bold);
          color: #3256FF;
        }
      }

    }

    &__list__item {
      margin-bottom: 8px;

      @include bp(680px) {
        // margin-bottom: 0;
        margin-right: 18px;

        &:last-of-type {
          padding-right: 18px;
        }
      }
    }

    &__link {
      cursor: pointer;
      position: relative;
      font-family: var(--f-regular);
      font-size: 13px;
      line-height: 2.75;
      transition: all .2s;

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: -15px;
        height: 18px;
        width: 5px;
        background-color: var(--brand-blue);
        opacity: 0;
        transition: opacity .2s;

        @include bp(880px) {
          left: -10px;
          height: 14px;
        }

        @include bp(680px) {
          width: 100%;
          top: 120%;
          left: 0;
          right: 0;
          height: 5px;
        }
      }

      &:hover {
        &::before {
          opacity: 1;
        }
      }

      @include bp(880px) {
        font-size: 12px;
      }

      @include bp(680px) {
        // line-height: normal;
        white-space: nowrap;
      }

    }
  }
</style>
